module.exports = __webpack_public_path__ + "static/acv-29ad81fb439a201d8795f46c8909d656.svg";